module.exports = CreateSharedReactContext;